import { Buffergs925ekssbch as Buffer } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { get_size2imoy2jq11jxl as get_size } from '../../../../ktor-ktor-io/io/ktor/utils/io/core/BytePacketBuilder.mjs';
import { generateNonceBlockingbv5f4wo6otfs as generateNonceBlocking } from './Crypto.web.mjs';
import { writeText19qfzm98fbm4l as writeText } from '../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { readByteArray1fhzfwi2j014k as readByteArray } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { toCharArray1qby3f4cdahde as toCharArray } from './Charset.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var digits;
function generateNonce(size) {
  _init_properties_Crypto_kt__txayzl();
  // Inline function 'io.ktor.utils.io.core.buildPacket' call
  var builder = new (Buffer())();
  while (get_size(builder) < size) {
    writeText(builder, generateNonceBlocking());
  }
  return readByteArray(builder, size);
}
var properties_initialized_Crypto_kt_8g5vqb;
function _init_properties_Crypto_kt__txayzl() {
  if (!properties_initialized_Crypto_kt_8g5vqb) {
    properties_initialized_Crypto_kt_8g5vqb = true;
    digits = toCharArray('0123456789abcdef');
  }
}
//region block: exports
export {
  generateNonce as generateNonce3td15vdvbmmke,
};
//endregion

//# sourceMappingURL=Crypto.mjs.map
